import { useQuery } from '@tanstack/react-query';
import type { Entitlements } from '@guabi/shared';
import { apiGet } from '@/lib/api';

export const entitlementsKey = (wedId: string) => ['entitlements', wedId] as const;

/**
 * What the plan allows, from the server.
 *
 * The same pure functions in `@guabi/shared/entitlements` run on both sides, so
 * the client can grey a button out before the server would refuse it — but the
 * **counts** come from here, never from whatever happens to be in the cache. A
 * count the browser worked out is a count the browser can be wrong about.
 */
export function useEntitlements(wedId: string) {
  return useQuery({
    queryKey: entitlementsKey(wedId),
    queryFn: () => apiGet<Entitlements>(`/weddings/${wedId}/entitlements`),
    // Caps move only when something is created or the plan changes, both of
    // which invalidate this key explicitly.
    staleTime: 60_000,
  });
}
